import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from '../Icon/Icon';
import useStyles from './SavedAddressesEmpty.styles';
const SavedAddressesEmpty = () => {
    const { classes } = useStyles();
    return (_jsxs("div", { className: classes.container, children: [_jsx(Icon, { icon: "person", className: classes.icon }), _jsxs("div", { className: classes.textContainer, children: [_jsx("h4", { className: classes.header, children: "You have no saved addresses in your address book." }), _jsx("p", { className: classes.body, children: "Enter your recipient details below to save for later use." })] })] }));
};
export default SavedAddressesEmpty;
